import { useRef, useCallback, useEffect } from 'react';

const fmtMoney = (v) => {
  const num = Number(v) || 0;
  if (num === 0) return '';
  const parts = num.toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join('.') + ' $';
};

const MoneyInput = ({ value, onChange, testId, style, disabled, readOnly, placeholder, tabIndex }) => {
  const inputRef = useRef(null);
  const isFocusedRef = useRef(false);

  // Mettre à jour la valeur affichée quand le parent change et le champ n'est pas actif
  useEffect(() => {
    if (!isFocusedRef.current && inputRef.current) {
      inputRef.current.value = fmtMoney(value);
    }
  }, [value]);

  const handleFocus = useCallback(() => {
    if (readOnly || disabled) return;
    isFocusedRef.current = true;
    const el = inputRef.current;
    if (el) {
      el.value = value ? String(value) : '';
      requestAnimationFrame(() => el.select());
    }
  }, [value, readOnly, disabled]);

  const handleBlur = useCallback(() => {
    isFocusedRef.current = false;
    const el = inputRef.current;
    if (el) {
      const num = parseFloat(el.value) || 0;
      el.value = fmtMoney(num);
      if (onChange) onChange(num);
    }
  }, [onChange]);

  const handleInput = useCallback((e) => {
    let v = e.target.value.replace(/[^\d.]/g, '');
    const parts = v.split('.');
    if (parts.length > 2) v = parts[0] + '.' + parts.slice(1).join('');
    if (e.target.value !== v) e.target.value = v;
  }, []);

  return (
    <input
      ref={inputRef}
      className="win-input no-spinner"
      type="text"
      inputMode="decimal"
      defaultValue={fmtMoney(value)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onInput={handleInput}
      placeholder={placeholder || '0.00 $'}
      disabled={disabled}
      readOnly={readOnly}
      data-testid={testId}
      tabIndex={tabIndex}
      style={{ textAlign: 'right', ...style }}
    />
  );
};

export default MoneyInput;
